<style src="./CZQSelect.css"></style>
<template>
	<input type="text" class="czq-select" readonly @click="open()" :placeholder="selectName"/>
</template>
<script>
import { CZQ2Boolean } from 'lib/util/utils'

export default {
	// {{{ data
	data () {
		return {
			selected: {
				name: null
			},
			clearable: true,
			filterCache: ''
		}
	},
	// }}}
	// {{{ props
	props: {
		value: {
			type: Object,
			default: null
		},
		filter: {
			type: Object,
			default () {
				return {}
			}
		},
		paging: {
			type: [String, Boolean],
			default: false
		},
		dataSource: {
			type: Function,
			default: () => Promise.resolve([])
		},
		searchable: {
			type: [String, Boolean],
			default: false
		},
		placeholder: {
			type: String,
			default: '请选择'
		}
	},
	// }}}
	// {{{ created
	created () {
		this.selected = this.value
		this.filterCache = ''
	},
	// }}}
	// {{{ methods
	methods: {
		// {{{ open
		open () {
			var options = {
				paging: CZQ2Boolean(this.paging),
				filter: Object.assign({}, this.filter),
				dataSource: this.dataSource,
				searchable: CZQ2Boolean(this.searchable),
				placeholder: this.placeholder
			}
			this.$czqPopupList(options).then(selected => {
				this.filterCache = JSON.stringify(this.filter)
				this.selected = selected
				this.$emit('input', selected)
			})
		}
		// }}}
	},
	// }}}
	// {{{ computed
	computed: {
		// {{{ selectName
		selectName () {
			var c = JSON.stringify(this.filter)
			if (this.filterCache !== c) {
				this.filterCache = ''
				return this.placeholder
			}
			return this.selected.name
		}
		// }}}
	}
	// }}}
}
</script>



// WEBPACK FOOTER //
// CZQSelect.vue?44db4b86